import React, { FC } from 'react';

import RadioGroup from 'devextreme-react/radio-group';

import { MethodOfReceptionType } from 'bus/methodOfReception/types';

type MethodReceptionProps = {
  value: number | undefined;
  onChange: any;
  methodTypes: MethodOfReceptionType[] | undefined;
};

const MethodReception: FC<MethodReceptionProps> = ({ value, onChange, methodTypes }) => {
  return (
    <div className="mt-2 mb-2">
      <RadioGroup
        items={methodTypes}
        value={value}
        layout="horizontal"
        onValueChange={onChange}
        valueExpr="id"
        displayExpr="name"
      />
    </div>
  );
};

export default MethodReception;
